import {
  StyleBannerCard,
  StyleLeftBannerWrapper,
  StyleRightBannerWrapper,
} from './style'
import Image from '@components/image'
import BannerImg from './banner.png'
import Typography from '@components/typography'
import Row from '@components/row'
import Button from '@components/button'
import Svg from '@components/svg'
import Modal from '@components/modal'
import { useState } from 'react'
import { Formik, Form } from 'formik'
import Fields from '@components/fields'
import { Constant } from '@utils'
import Column from '@components/column'
import { AvailabilitySchema } from '@validations'
import { Availability } from '@apis'
import { store, Actions } from '@store'
import { useSelector } from 'react-redux'
const Banner = () => {
  const [visible, setVisible] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const { data: availabilities } = useSelector(
    (state: any) => state.availabilities,
  )
  const [initialValues] = useState({
    day: '',
    isAlwaysOnline: false,
    shift: 'morning',
    slots: {
      morning: [],
      afternoon: [],
      evening: [],
    },
  })
  const submitHandler = async (values) => {
    setLoading(true)
    const payload: any = {
      day: values?.day,
      isAlwaysOnline: values?.isAlwaysOnline,
      slots: {},
    }

    Object.entries(values?.slots).flatMap(([shift, times]: any) =>
      times.map((time, index) => {
        const [startTime, endTime] = time.split('-')
        const item = {
          interval: 30,
          startTime,
          endTime,
          index,
        }
        payload.slots[shift] = [...(payload.slots[shift] || []), item]
      }),
    )
    await Availability.create({
      data: payload,
    })
      .then((resp) => {
        const findIndex = Constant.weekDays?.findIndex(
          (day: any) => day?.label == resp?.day,
        )
        const updatedAvailabilities = [...availabilities]
        updatedAvailabilities[findIndex] = resp
        store.dispatch(Actions.set('availabilities', updatedAvailabilities))
        setVisible(false)
      })
      .catch(() => {})
    setLoading(false)
  }
  return (
    <>
      <StyleBannerCard>
        <StyleLeftBannerWrapper>
          <Typography content="Schedule on Your Terms" size={24} tc="primary" />
          <Typography
            content={`"Smart scheduling at your fingertips — take time off or open new slots."`}
            size={20}
            tc="text"
          />
          <Row colGap={20} styleRow="margin-top:10px;">
            <Button
              title="Mark Days Off"
              leftComponent={<Svg svg="usermark" color="primary" />}
              outline
              height={45}
            />
            <Button
              title="Add Availability"
              leftComponent={<Svg svg="time" color="white" />}
              height={45}
              onClick={() => {
                setVisible(true)
              }}
            />
          </Row>
        </StyleLeftBannerWrapper>
        <StyleRightBannerWrapper>
          <Image src={BannerImg} />
        </StyleRightBannerWrapper>
      </StyleBannerCard>
      <Modal
        visible={visible}
        title="Add Availability"
        onClose={() => {
          setVisible(false)
        }}
      >
        <Formik
          initialValues={initialValues}
          onSubmit={submitHandler}
          validationSchema={AvailabilitySchema.validationSchema}
          enableReinitialize
        >
          {({ handleSubmit, values }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <Column rowGap={20}>
                  <Fields.DropDown
                    name="day"
                    options={Constant.weekDays}
                    titleAsKey="label"
                    valueAsKey="label"
                    placeholder="Day"
                    label="Day"
                  />
                  <Fields.Switch
                    name="isAlwaysOnline"
                    label="Is Always Online"
                  />
                  <Fields.ChooseButton
                    label="Available Time"
                    name="shift"
                    items={[
                      {
                        label: 'Morning',
                        value: 'morning',
                      },
                      {
                        label: 'Afternoon',
                        value: 'afternoon',
                      },
                      {
                        label: 'Evening',
                        value: 'evening',
                      },
                    ]}
                    titleAsKey="label"
                    valueAsKey="value"
                    multiple={false}
                  />
                  <Fields.ChooseButton
                    name={`slots[${values?.shift}]`}
                    items={Constant.slots[values?.shift]?.map((slot) => {
                      return {
                        label: `${slot?.startTime}-${slot?.endTime}`,
                      }
                    })}
                    titleAsKey="label"
                    valueAsKey="label"
                  />
                  <Button
                    title="Submit"
                    styleButton="width:100%"
                    height={45}
                    loading={loading}
                    type="submit"
                  />
                </Column>
              </Form>
            )
          }}
        </Formik>
      </Modal>
    </>
  )
}

export default Banner
